import taggedStringBase from './taggedStringBase'

export default taggedStringBase(encodeURIComponent)
